export default __webpack_public_path__ + "static/media/sec1.14ae5a4b.png";